module.exports = __webpack_public_path__ + "static/media/save_cash_icon_white.02ff1339.svg";